module.exports = __webpack_public_path__ + "static/media/ac1.306cdaae.jpg";